import { useEffect, useState } from 'react';
import { EscrowRequestTable } from './EscrowRequestTable';
import { CreateEscrowForm } from './createEscrowForm';
import { Container } from 'react-bootstrap';
import { CallAPIGetPromise } from 'Common/commaon';
import './escrow-requests.css';

export default function EscrowRequest() {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [requests, setRequests] = useState([]);

  const handleCreateRequest = (newRequest:any) => {
  
  };

  const handleDeleteRequest = (id:any) => {
  };

  useEffect(()=>{
CallAPIGetPromise("/contract/get-escrow-req").then((res:any)=>{
    if(res?.data?.result){
   setRequests(res?.data?.result)
    }
}).catch(()=>{

})
  },[])
  console.log(requests)

  return (
    <div className='tailwind-prefix page-content escrow-requests-page'>
  <Container fluid>

   <div className="size-full bg-gray-50 escrow-requests-shell">
      <div className=" ">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <div className="mb-2 text-[18px] font-[500]">Escrow Request Management</div>
            <div className="text-gray-600">Manage and track all escrow requests</div>
          </div>
          {/* <button
            onClick={() => setShowCreateForm(!showCreateForm)}
            className="px-3 border-0  py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            {showCreateForm ? 'Cancel' : '+ New Request'}
          </button> */}
        </div>

        {showCreateForm && (
          <div className="mb-6">
            <CreateEscrowForm onSubmit={handleCreateRequest} />
          </div>
        )}

        <EscrowRequestTable
          requests={requests}
          onDelete={handleDeleteRequest}
        />
      </div>
    </div>
  </Container>

    </div>
 
  );
}
